import React, { useState, useEffect } from 'react'
import SidebarCard from '../../elements/SidebarCard'

export default function ReportSection({ ReportData }) {
    const [reports, setReports] = useState([])
    useEffect(() => {
        setReports(ReportData)
    }, [ReportData])
    return (
        reports?.length > 0 && reports != null && reports != undefined && reports[0]?.slug &&
        <>
            <div className="shadow-md rounded my-4 px-4 py-4">
                <h3 className="text-lg text-[#1b5df3] font-semibold pb-2 border-b-2"><i className='fa fa-file fa-lg text-[#1b5df3]'></i>  Related Reports</h3>
                <div className='mt-2 pr-2 max-h-60 overflow-auto'>
                    <div className="flex flex-col items-center space-y-2">
                        {
                            reports?.map((card, index) => (
                                <SidebarCard
                                    key={index}
                                    title={card.value}
                                    description=''
                                    imageSrc={process.env.IMG_CDN + "img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg"}
                                    link={process.env.APP_URL + "/report-store/" + card.slug}
                                    altText={card.value}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
